var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { i18nSymbol } from '@/i18n';
import { ReportTemplateData } from '@/services/report/create-report-template-data';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TemplateEditDialogService } from './template-edit-dialog-service.interface';
let TemplateEditCommandContribution = class TemplateEditCommandContribution {
    constructor(_templateEditDialogService, _i18n, _reportTemplateData) {
        this._templateEditDialogService = _templateEditDialogService;
        this._i18n = _i18n;
        this._reportTemplateData = _reportTemplateData;
    }
    registerCommands(commandRegistry) {
        commandRegistry.registerCommand({
            id: 'open-template-edit',
        }, {
            execute: () => {
                const title = this._i18n.t('Report.ReportTemplate.SaveAs');
                const { name: _name, catalog } = this._reportTemplateData.getData();
                const copyName = this._i18n.t('Report.CopyReport.CopyTitle', { name: _name });
                return this._templateEditDialogService.open({
                    title,
                    //@ts-ignore
                    input: {
                        name: copyName,
                        catalog: catalog,
                    },
                });
            },
        });
        commandRegistry.registerCommand({
            id: 'close-template-edit',
        }, {
            execute: () => {
                return this._templateEditDialogService.close();
            },
        });
    }
};
TemplateEditCommandContribution = __decorate([
    injectable(),
    __param(0, inject(TemplateEditDialogService)),
    __param(1, inject(i18nSymbol)),
    __param(2, inject(ReportTemplateData)),
    __metadata("design:paramtypes", [typeof (_a = typeof TemplateEditDialogService !== "undefined" && TemplateEditDialogService) === "function" ? _a : Object, Object, typeof (_b = typeof ReportTemplateData !== "undefined" && ReportTemplateData) === "function" ? _b : Object])
], TemplateEditCommandContribution);
export { TemplateEditCommandContribution };
